<div class="header">
  <h1>Tests</h1>
</div>
<div class="content">
  <object #avplayer id="avplayer" type="application/avplayer" aria-label="avplayer"></object>
  <div class="actions">
    <button type="button" class="htv-selectable htv-button" (click)="start()">Start tests</button>
    <button type="button" class="htv-selectable htv-button" (click)="restartApp()">Reload App</button>
  </div>
  <div class="reports">
    <div *ngFor="let report of reports" class="report htv-selectable">
      <div [ngClass]="'report--' + report.state" class="report__title">
        {{ report.name }}
      </div>
      <div class="report__logs">
        <div *ngFor="let log of report.logs" [ngClass]="'log--' + log.level">
          {{ log.msg }}
        </div>
      </div>
    </div>
  </div>
</div>
